"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidatedInput = exports.InputLabelField = exports.InputErrorField = exports.Input = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
const _excluded = ["multiline"],
  _excluded2 = ["labelText"],
  _excluded3 = ["id", "labelText", "errorText", "hideErrorField", "multiline", "style", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const Input = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
      multiline
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_styles.Input, _extends({
    ref: ref,
    as: multiline ? 'textarea' : 'input' // Handled by styled-components
  }, rest));
});

// LABELS
exports.Input = Input;
Input.propTypes = {
  /** This will render `<textarea />` tag, instead of `<input />` */multiline: _propTypes.default.bool
};
const InputLabelField = _ref2 => {
  let {
      labelText
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return labelText ? /*#__PURE__*/_react.default.createElement(_styles.Label, rest, labelText) : null;
};

// ERRORS
exports.InputLabelField = InputLabelField;
InputLabelField.propTypes = {
  /** Explanatory text that would appear above the field, describing its purpose. */labelText: _propTypes.default.string
};
const InputErrorField = ({
  hideErrorField,
  errorText
}) => {
  return !hideErrorField ? /*#__PURE__*/_react.default.createElement(_styles.Error, {
    role: "status",
    title: "input error"
  }, errorText) : null;
};

// Validated Input. Shortcuts for label and errors. Suitable for DialogInput replacement.
exports.InputErrorField = InputErrorField;
InputErrorField.propTypes = {
  /** Explanatory text that would appear in red under the field. */errorText: _propTypes.default.string,
  /** By default there is space reserved for the error that is fixed to be ~14px. Set this to `false` to hide it. */hideErrorField: _propTypes.default.bool
};
const ValidatedInput = _ref3 => {
  let {
      id,
      labelText,
      errorText,
      hideErrorField,
      multiline,
      style,
      className
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react.default.createElement(_styles.Wrapper, {
    className: className,
    style: style,
    "aria-label": 'validated input'
  }, /*#__PURE__*/_react.default.createElement(InputLabelField, {
    labelText: labelText,
    htmlFor: id
  }), /*#__PURE__*/_react.default.createElement(Input, _extends({
    id: id,
    multiline: multiline
  }, rest)), /*#__PURE__*/_react.default.createElement(InputErrorField, {
    hideErrorField: hideErrorField,
    errorText: errorText
  }));
};
exports.ValidatedInput = ValidatedInput;
ValidatedInput.propTypes = {
  /** Used to match your input with its label. Add for accessibility and testing reasons. */id: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  style: _propTypes.default.any,
  /** This will render `<textarea />` tag, instead of `<input />` */multiline: _propTypes.default.bool,
  /** Explanatory text that would appear in red under the field. */errorText: _propTypes.default.string,
  /** By default there is space reserved for the error that is fixed to be ~14px. Set this to `false` to hide it. */hideErrorField: _propTypes.default.bool,
  /** Explanatory text that would appear above the field, describing its purpose. */labelText: _propTypes.default.string
};